var React = require('react');

function CloudyInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M62.5 125C97.0178 125 125 97.0178 125 62.5C125 27.9822 97.0178 0 62.5 0C27.9822 0 0 27.9822 0 62.5C0 97.0178 27.9822 125 62.5 125ZM183 405C255.902 405 315 345.902 315 273C315 200.098 255.902 141 183 141C110.098 141 51 200.098 51 273C51 345.902 110.098 405 183 405Z","fill":"#F9FAFA"}));
}

CloudyInline.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 315 405","fill":"none"};

module.exports = CloudyInline;

CloudyInline.default = CloudyInline;
